import React, { useEffect } from 'react';
import TravelCalculator from '../../common/components/offset/TravelCalculator'



const DemoTravelOffset = () => {

    return (
        <>
        DEMO
            <TravelCalculator merchantCode={'BES_GB_ST_JAMES_QUARTER'} />
        </>
    )
};


export default DemoTravelOffset;